import { render } from "./RecommendMode.vue?vue&type=template&id=2a9a2d55&scoped=true"
import script from "./RecommendMode.vue?vue&type=script&lang=js"
export * from "./RecommendMode.vue?vue&type=script&lang=js"

import "./RecommendMode.vue?vue&type=style&index=0&id=2a9a2d55&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9a2d55"]])

export default __exports__